import { z } from 'zod';
import { MoneySchema } from './common.js';
export const CustomerSchema = z.object({
    id: z.uuid(),
    companyId: z.uuid(),
    code: z.string().min(1).max(32),
    nameTh: z.string().min(1),
    taxId: z.string().nullable().optional(),
    terms: z.string().nullable().optional(),
    creditLimit: z.union([MoneySchema, z.coerce.number().nonnegative()]),
    ytdSales: z.union([MoneySchema, z.coerce.number().nonnegative()]),
    isActive: z.boolean(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
});
export const CreateCustomerSchema = CustomerSchema.omit({
    id: true,
    createdAt: true,
    updatedAt: true,
});
export const UpdateCustomerSchema = CreateCustomerSchema.partial().omit({
    companyId: true,
});
//# sourceMappingURL=customer.js.map